namespace Seac.Commons {
	/** Classe di costanti utilizzata per non scrivere stringhe all'interno del codice */
	export class Constants {
		public static itemKeyTuttiNumber				: number	= -1;
		public static itemKeyNotSetNumber				: number	=  0;

		public static appContainerId					: string	= 'app-container';

		public static stringEmpty						: string	= '';
		public static body								: string	= 'body';
		public static checked							: string	= 'checked';
		public static disabled							: string	= 'disabled';
		public static displayAttribute					: string	= 'display';
		public static displayNone						: string	= 'none';
		public static displayBlock						: string	= 'block';
		public static enabled							: string	= 'enabled';
		public static hidden							: string	= 'hidden'
		public static targetBlank						: string	= '_blank';
		public static changeEvent						: string	= 'change';
		public static true								: string	= 'true';
		public static false								: string	= 'false';
		public static clickEvent						: string	= 'click';
		public static scrollEvent						: string	= 'scroll';
		public static mouseDownEvent					: string	= 'mousedown';
		public static button							: string	= 'button';
		public static mouseEnterEvent					: string	= 'mouseenter';
		public static mouseLeaveEvent					: string	= 'mouseleave';
		public static orientationChangeEvent			: string	= 'orientationchange';
		public static readonly							: string	= 'readonly';
		public static bootstrapDNoneClass				: string	= 'd-none';
		public static bootstrapCheckBoxIndeterminate	: string	= 'indeterminate';
		public static bootstrapInputValidationError		: string	= 'input-validation-error';
		public static dataPrefix						: string	= 'data-';
		public static imageSource						: string	= 'src';
		public static elementName						: string	= 'name';
		public static elementType						: string	= 'type';
		public static inputElement						: string	= 'input';
		public static selectElement						: string	= 'select';
		public static keyDownEvent						: string	= 'keydown';
		public static keyUpEvent						: string	= 'keyup';
		public static keyPressEvent						: string	= 'keypress';
		public static submitEvent						: string	= 'submit';
		public static formActionAttribute				: string	= 'action';
		public static nodeName							: string	= 'nodeName';
		public static tdElement							: string	= 'td';
		public static anchorElement						: string	= 'a';
		public static showCollapseEvent					: string	= 'show.bs.collapse';
		public static hideCollapseEvent					: string	= 'hide.bs.collapse';
		public static active							: string	= 'active';
		public static estensionePDF						: string	= '.PDF';
		public static col4								: string	= 'col-4';
		public static col6								: string	= 'col-6';
		public static col12								: string	= 'col-12';
		public static null								: string	= 'null';
		public static href								: string	= 'href';
		public static iElement							: string	= 'i';
		public static idAttribute						: string	= 'id';
		public static formElement						: string	= 'form';
		public static location							: string	= 'Location';
		public static rowsAttr							: string	= 'rows';
		public static style								: string	= 'style';
		public static iframeElement						: string	= 'iframe';
		public static sourceAttribute					: string	= 'src';
		public static cssClassAttribute					: string	= 'class';

		public static positionAbsolute					: string	= 'absolute';
		public static attributeTitle					: string	= 'title';

		public static codiceStatoItalia					: string	= 'IT';
		public static codiceDestinatarioEmpty			: string	= '0000000';

		public static sezionaleNullo					: number	= 255;

		public static DevExpress = {
			dxDataSource				: 'dataSource',
			dxInstance					: 'instance',
			dxKeyPressEvent				: 'keyPress',
			dxKeyDownEvent				: 'keyDown',
			dxValueChangedEvent			: 'valueChanged',
			dxUploadErrorEvent			: 'uploadError',
			dxUploadSuccessEvent		: 'uploaded',
			dxUploadUrlOption			: 'uploadUrl',
			dxUploadStartedEvent		: 'uploadStarted',
			dxUploadMode				: 'uploadMode',
			dxUploadModeUseForm			: 'useForm',
			dxUploadMultiple			: 'multiple',
			dxUploadSelectButtonText	: 'selectButtonText',
			dxUploadLabelText			: 'labelText',
			dxUploadAccept				: 'accept',
			dxDisplayExprOption			: 'displayExpr',
			dxItemTemplate				: 'itemTemplate',
			dxSelectionChanged			: 'selectionChanged',
			dxChanged					: 'changed',
			dxOpenedEvent				: 'opened',
			dxValue						: 'value',
			dxTextValue					: 'text',
			dxValueExpr					: 'valueExpr',
			dxRowClick					: 'rowClick',
			dxDisabled					: 'disabled',
			dxCustom					: 'custom',
			dxSummary					: 'summary',
			dxContentReady				: 'contentReady',
			dxCellPrepared				: 'cellPrepared',
			dxRowPrepared				: 'rowPrepared',
			dxDispose					: 'dispose',
			dxMin						: 'min',
			dxMax						: 'max',
			dxName						: 'name',
			dxWidget					: 'dx-widget',
			dxNumberBox					: 'dx-numberbox',
			dxSelectBox					: 'dx-selectbox',
			dxDropDownBox				: 'dx-dropdownbox',
			dxStateDisabled				: 'dx-state-disabled',
			dxTitle						: 'title',
			dxVisible					: 'visible',
			dxCaption					: 'caption',
			dxCurrentDate				: 'currentDate',
			dxAppointmentClickEvent		: 'appointmentClick',
			dxAppointmentDblClickEvent	: 'appointmentDblClick',
			dxHoverStartEvent			: 'dxhoverstart',
			dxHoverEndEvent				: 'dxhoverend',
			dxEditorPreparing			: 'editorPreparing',
			dxFilterRow					: 'filterRow',
			dxDataSourceChanged	 		: 'changed',
			dxSchedulerCurrentView		: 'currentView',
			dxSchedulerViewAgenda		: 'agenda',
			dxSchedulerViewMonth		: 'month',
			dxChartStartValue			: 'startValue',
			dxChartEndValue				: 'endValue',
			focusedRowKey				: 'focusedRowKey',
			dxIsValid					: 'isValid',
			dxItems						: 'items',
			dxItemRendered				: 'itemRendered',
			dxSelectedItem				: 'selectedItem',
			showClearButton				: 'showClearButton',
			dxOnRowExpandedEvent		: 'rowExpanded',
			dxOnRowExpandingEvent		: 'rowExpanding',
			dxOnRowPreparedEvent		: 'rowPrepared',
			dxNoDataText				: 'noDataText',
			dxColumns					: 'columns',
			dxClick						: 'dxclick',
			dxTextBoxElement			: 'dx-textbox',
			dxLoadPanelElement			: 'dx-loadpanel',
			dxWidth						: 'width',
			dxPlaceholder				: 'placeholder',
			dxSeries					: 'series',
			dxCustomizeLabel			: 'customizeLabel',
			dxOnCellContextMenu			: 'onCellContextMenu',
			dxOnAppointmentContextMenu	: 'onAppointmentContextMenu',
			dxOnAppointmentDblClick		: 'onAppointmentDblClick',
			dxOnOptionChanged			: 'onOptionChanged',
			dxGridOnOptionChanged		: 'optionChanged',
			dxClearButtonAreaClassName	: 'dx-clear-button-area',
			dxPagingPageIndex			: 'paging.pageIndex',

			dxCurrentView				: 'currentView',
			dxCurrentViewMonth			: 'month',
			dxCurrentViewAgenda			: 'agenda',
			dxCurrentViewDay			: 'day',
			dxCellClick					: 'onCellClick'
		};

		public static Bootstrap = {
			modalShowEvent		: 'show.bs.modal',
			modalShownEvent		: 'shown.bs.modal',
			modalHideEvent		: 'hide.bs.modal',
			modalHiddenEvent	: 'hidden.bs.modal',
			modalToggle			: <'toggle' | 'show' | 'hide' | 'handleUpdate' | 'dispose'>'toggle',
			modalShow			: <'toggle' | 'show' | 'hide' | 'handleUpdate' | 'dispose'>'show',
			modalHide			: <'toggle' | 'show' | 'hide' | 'handleUpdate' | 'dispose'>'hide',
			modalHandleUpdate	: <'toggle' | 'show' | 'hide' | 'handleUpdate' | 'dispose'>'handleUpdate',
			modalDispose		: <'toggle' | 'show' | 'hide' | 'handleUpdate' | 'dispose'>'dispose',

			dropdownShowEvent	: 'show.bs.dropdown',
			dropdownShownEvent	: 'shown.bs.dropdown',
			dropdownHideEvent	: 'hide.bs.dropdown',
			dropdownHiddenEvent	: 'hidden.bs.dropdown',
			dropdownTargetData	: 'bs.dropdown',

			collapseToggle		: <'toggle' | 'show' | 'hide' | 'dispose'>'toggle',
			collapseShow		: <'toggle' | 'show' | 'hide' | 'dispose'>'show',
			collapseHide		: <'toggle' | 'show' | 'hide' | 'dispose'>'hide',
			collapseDispose		: <'toggle' | 'show' | 'hide' | 'dispose'>'dispose',

			tooltipShowEvent	: 'show.bs.tooltip',
			tooltipShownEvent	: 'shown.bs.tooltip',
			tooltipHideEvent	: 'hide.bs.tooltip',
			tooltipHiddenEvent	: 'hidden.bs.tooltip',
			tooltipShow			: <'show' | 'hide'>'show',
			tooltipHide			: <'show' | 'hide'>'hide',

			dNoneClass			: 'd-none'
		};

		public static CSS = {
			marginLeft	: 'margin-left'
		};

		public static FontAwesome = {
			faThumbsDown			: '\uf165',
			faThumbsUp				: '\uf164',
			faExclamationTriangle	: '\uf071'
		};
	}

	export enum DxDataGridRowType {
		header			= 'header',
		group			= 'group',
		detail			= 'detail',
		filter			= 'filter',
		totalFooter		= 'totalFooter',
		freeSpace		= 'freeSpace',
		detailAdaptive	= 'detailAdaptive',
		groupFooter		= 'groupFooter',
		data			= 'data'
	}

	/** Valori possibili per il calcolo della riga ri riassunto della riga delle griglie */
	export enum DevExpressSummaryProcess {
		start		= 'start',
		calculate	= 'calculate',
		finalize	= 'finalize'
	}

	/** Tipo ministeriale del documento */
	export enum TipoDocumentoMinisteriale {
		TD01	= 'TD01',
		TD02	= 'TD02',
		TD03	= 'TD03',
		TD04	= 'TD04',
		TD05	= 'TD05',
		TD06	= 'TD06',
		TD07	= 'TD07',
		TD08	= 'TD08',
		TD09	= 'TD09',
		TD16	= 'TD16',
		TD17	= 'TD17',
		TD18	= 'TD18',
		TD19	= 'TD19',
		TD20	= 'TD20',
		TD21	= 'TD21',
		TD22	= 'TD22',
		TD23	= 'TD23',
		TD24	= 'TD24',
		TD25	= 'TD25',
		TD26	= 'TD26',
		TD27	= 'TD27',
		TD28	= 'TD28',
		TD29	= 'TD29'
	}

	export class DocumentoMinisteriale {
		/**
		 * Data la sigla di un documento contabile restituisce la relativa descrizione localizzata.
		 * @param tipoDocumentoSigla Sigla della tipologia di documento contabile
		 * @returns Descrizione corrispondente alla sigla passata in input
		 */
		public static tipoDocumentoContabileSiglaToDescrizione(tipoDocumentoSigla: string): string {
			switch (tipoDocumentoSigla.trim()) {
				case TipoDocumentoMinisteriale.TD01: return Resources.Fatturazione.enum_tipo_documento_fattura;
				case TipoDocumentoMinisteriale.TD02: return Resources.Fatturazione.enum_tipo_documento_acconto_anticipo_fattura;
				case TipoDocumentoMinisteriale.TD03: return Resources.Fatturazione.enum_tipo_documento_acconto_anticipo_parcella;
				case TipoDocumentoMinisteriale.TD04: return Resources.Fatturazione.enum_tipo_documento_nota_di_credito;
				case TipoDocumentoMinisteriale.TD05: return Resources.Fatturazione.enum_tipo_documento_nota_di_debito;
				case TipoDocumentoMinisteriale.TD06: return Resources.Fatturazione.enum_tipo_documento_parcella;
				case TipoDocumentoMinisteriale.TD07: return Resources.Fatturazione.enum_tipo_documento_fattura_semplificata;
				case TipoDocumentoMinisteriale.TD08: return Resources.Fatturazione.enum_tipo_documento_nota_di_credito_semplificata;
				case TipoDocumentoMinisteriale.TD09: return Resources.Fatturazione.enum_tipo_documento_nota_di_debito_semplificata;

				case TipoDocumentoMinisteriale.TD16: return Resources.Fatturazione.enum_tipo_documento_integrazione;
				case TipoDocumentoMinisteriale.TD17: return Resources.Fatturazione.enum_tipo_documento_integrazione;
				case TipoDocumentoMinisteriale.TD18: return Resources.Fatturazione.enum_tipo_documento_integrazione;
				case TipoDocumentoMinisteriale.TD19: return Resources.Fatturazione.enum_tipo_documento_integrazione;
				case TipoDocumentoMinisteriale.TD20: return Resources.Fatturazione.enum_tipo_documento_autofattura;
				case TipoDocumentoMinisteriale.TD21: return Resources.Fatturazione.enum_tipo_documento_autofattura;
				case TipoDocumentoMinisteriale.TD22: return Resources.Fatturazione.enum_tipo_documento_estrazione_beni;
				case TipoDocumentoMinisteriale.TD23: return Resources.Fatturazione.enum_tipo_documento_estrazione_beni;
				case TipoDocumentoMinisteriale.TD24: return Resources.Fatturazione.enum_tipo_documento_fattura_differita;
				case TipoDocumentoMinisteriale.TD25: return Resources.Fatturazione.enum_tipo_documento_fattura_differita;
				case TipoDocumentoMinisteriale.TD26: return Resources.Fatturazione.enum_tipo_documento_cessione_beni;
				case TipoDocumentoMinisteriale.TD27: return Resources.Fatturazione.enum_tipo_documento_autofattura;
				case TipoDocumentoMinisteriale.TD28: return Resources.Fatturazione.enum_tipo_documento_integrazione;
				case TipoDocumentoMinisteriale.TD29: return Resources.Fatturazione.enum_tipo_documento_omessa_irregolare_fatturazione;

				default: return "---";
			}
		}
	}
}
